import { socialApiClient } from '@/shared/api-client/social-api-client';

// scheduled + active 상태의 캠페인 수 (Campaign Slot 사용량)
export const FetchCampaignSlot = async (
  workspace_id: string,
  signal?: AbortSignal,
): Promise<{ count: number }> => {
  const res = await socialApiClient.get(`workspaces/${workspace_id}/campaigns/count`, {
    signal,
  });
  return await res.json();
};
